const createTracker = (getLayerData) => (hitType, layerData) => ({
  type: 'GTM_TRACK',
  hitType,
  ...getLayerData(layerData),
});

export const track = createTracker((payload) => ({ payload }));
